
  <template>
  <div class="manager_box">
    <div class="lw_busadd">
      <div class="lw_center">
        <p>今日数据</p>
        <div
          class="Information_sorting pointer"
          @click="go_details('resume_download')"
        >
          <img src="/static/img/icon/data.png" alt />
          <div>
            <p>今日线索公海下载</p>
            <span>{{ lwbus_day_data.resume_clue_download }}</span>
          </div>
        </div>
        <div
          class="Information_sorting pointer"
          @click="go_details('login_detail')"
        >
          <img src="/static/img/icon/data.png" alt />
          <div>
            <p>今日登录</p>
            <span>{{ lwbus_day_data.login_count }}</span>
          </div>
        </div>
        <div
          class="Information_sorting pointer"
          @click="go_details('resume_clue')"
        >
          <img src="/static/img/icon/data.png" alt />
          <div>
            <p>今日简历线索</p>
            <span>{{ lwbus_day_data.today_resume_clue_data }}</span>
          </div>
        </div>
        <div
          class="Information_sorting pointer"
          @click="go_details('setting_company')"
        >
          <img src="/static/img/icon/data.png" alt />
          <div>
            <p>今日完善公司</p>
            <span>{{ lwbus_day_data.is_setting_count }}</span>
          </div>
        </div>
        <div class="Information_sorting pointer" @click="go_details('enroll')">
          <img src="/static/img/icon/data.png" alt />
          <div>
            <p>今日报名人数</p>
            <span>{{ lwbus_day_data.today_enroll_count }}</span>
          </div>
        </div>
        <div
          class="Information_sorting pointer"
          @click="go_details('create_jd')"
        >
          <img src="/static/img/icon/data.png" alt />
          <div>
            <p>今日创建jd</p>
            <span>{{ lwbus_day_data.today_jd }}</span>
          </div>
        </div>
        <div class="Information_sorting pointer" @click="go_details('resume')">
          <img src="/static/img/icon/data.png" alt />
          <div>
            <p>今日简历</p>
            <span>{{ lwbus_day_data.today_resume_count }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="lw_busadd">
      <div class="lw_center">
        <p>30日数据</p>
        <div
          class="Information_sorting pointer"
          @click="go_details('resume_download', '30')"
        >
          <img src="/static/img/icon/data.png" alt />
          <div>
            <p>30日线索公海下载</p>
            <span>{{ lwbus_month_data.resume_clue_download }}</span>
          </div>
        </div>
        <div
          class="Information_sorting pointer"
          @click="go_details('login_detail', '30')"
        >
          <img src="/static/img/icon/data.png" alt />
          <div>
            <p>30日登录</p>
            <span>{{ lwbus_month_data.login_count }}</span>
          </div>
        </div>
        <div
          class="Information_sorting pointer"
          @click="go_details('resume_clue', '30')"
        >
          <img src="/static/img/icon/data.png" alt />
          <div>
            <p>30日简历线索</p>
            <span>{{ lwbus_month_data.today_resume_clue_data }}</span>
          </div>
        </div>
        <div
          class="Information_sorting pointer"
          @click="go_details('setting_company', '30')"
        >
          <img src="/static/img/icon/data.png" alt />
          <div>
            <p>30日完善公司</p>
            <span>{{ lwbus_month_data.is_setting_count }}</span>
          </div>
        </div>
        <div
          class="Information_sorting pointer"
          @click="go_details('enroll', '30')"
        >
          <img src="/static/img/icon/data.png" alt />
          <div>
            <p>30日报名人数</p>
            <span>{{ lwbus_month_data.today_enroll_count }}</span>
          </div>
        </div>
        <div
          class="Information_sorting pointer"
          @click="go_details('create_jd', '30')"
        >
          <img src="/static/img/icon/data.png" alt />
          <div>
            <p>30日创建jd</p>
            <span>{{ lwbus_month_data.today_jd }}</span>
          </div>
        </div>
        <div
          class="Information_sorting pointer"
          @click="go_details('resume', '30')"
        >
          <img src="/static/img/icon/data.png" alt />
          <div>
            <p>30日简历</p>
            <span>{{ lwbus_month_data.today_resume_count }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="lw_busadd">
      <div class="lw_center">
        <p>用户数据</p>
        <div
          class="Information_sorting pointer"
          @click="go_details('enterprise', '', 'user')"
        >
          <img src="/static/img/icon/data.png" alt />
          <div>
            <p>企业数量</p>
            <span>{{ lw_data.all_user_count || 0 }}</span>
          </div>
        </div>
        <div
          class="Information_sorting pointer"
          @click="go_details('experience', '', 'user')"
        >
          <img src="/static/img/icon/data.png" alt />
          <div>
            <p>体验企业数量</p>
            <span>{{ lw_data.experience_user_count || 0 }}</span>
          </div>
        </div>
        <div
          class="Information_sorting pointer"
          @click="go_details('pay_user', '', 'user')"
        >
          <img src="/static/img/icon/data.png" alt />
          <div>
            <p>付费企业数量</p>
            <span>{{ lw_data.pay_user_count || 0 }}</span>
          </div>
        </div>
        <div
          class="Information_sorting pointer"
          @click="go_details('normal', '', 'user')"
        >
          <img src="/static/img/icon/data.png" alt />
          <div>
            <p>正常企业数量</p>
            <span>{{ lw_data.use_user_count || 0 }}</span>
          </div>
        </div>
        <div
          class="Information_sorting pointer"
          @click="go_details('pass_user', '', 'user')"
        >
          <img src="/static/img/icon/data.png" alt />
          <div>
            <p>到期企业数量</p>
            <span>{{ lw_data.pass_user_count || 0 }}</span>
          </div>
        </div>
        <div
          class="Information_sorting pointer"
          @click="go_details('create_project', '', 'user')"
        >
          <img src="/static/img/icon/data.png" alt />
          <div>
            <p>创建项目总数</p>
            <span>{{ lw_data.create_project }}</span>
          </div>
        </div>
        <div
          class="Information_sorting pointer"
          @click="go_details('today_create', '', 'user')"
        >
          <img src="/static/img/icon/data.png" alt />
          <div>
            <p>今日创建项目</p>
            <span>{{ lw_data.today_create_project || 0 }}</span>
          </div>
        </div>

        <!-- <div class="Information_sorting pointer">
          <img src="/static/img/icon/data.png" alt />
          <div>
            <p>今日完善公司信息数量</p>
            <span>{{ lw_data.is_setting_count }}</span>
          </div>
        </div>-->

        <!-- 
        <div class="Information_sorting pointer">
          <img src="/static/img/icon/data.png" alt />
          <div>
            <p>求职者入职数量</p>
            <span>{{ lw_data.resume_entry_data }}</span>
          </div>
        </div>-->
      </div>
    </div>
    <div class="lw_busadd">
      <div class="lw_center">
        <p>体验账号分布 - 体验账号总数:{{ experience_place_datacount }}</p>
        <div
          class="Information_sorting pointer"
          v-for="(item, index) in lw_data.experience_place_data"
          :key="index"
          @click="go_city_details('experience_user',item)"
        >
          <i style="color: #efb336" class="iconfont icontiyan img"></i>
          <div>
            <p>{{ item.place_name ? item.place_name : "其他" }}</p>
            <span>{{ item.place_count }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="lw_busadd">
      <div class="lw_center">
        <p>
          雷达线索分布 - 城市雷达线索数:{{ lw_data.resume_clue_total_data }}
        </p>
        <div
          class="Information_sorting pointer"
          v-for="(item, index) in clue_list_date"
          :key="index"
          @click="go_city_details('resume_clue',item)"
        >
          <i style="color: #41b883" class="iconfont iconleida img"></i>
          <div>
            <p>{{ item.name }}</p>
            <span>{{ item.value }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="lw_busadd">
      <div class="lw_center">
        <p>
          简历分布 - 城市简历分布数量:{{ lw_data.resume_total_count }}；
          未填写简历数量:{{ resume_dict_name }}
        </p>
        <div
          class="Information_sorting pointer"
          v-for="(item, index) in resume_dict_date"
          :key="index"
          @click="go_city_details('resume_detail',item)"
        >
          <i style="color: #1296db" class="iconfont iconjianli img"></i>
          <div>
            <p>{{ item.name == "null" ? "未填" : item.name }}</p>
            <span>{{ item.value }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { require } from "@/utils/http_request.js";
export default {
  data() {
    return {
      lw_data: {
        loading: false,
        clue_data_loading: false,
        info_loading: false,
        all_user_count: 0, //总用户数量
        experience_place_data: [], //体验用户地区分布
        experience_user_count: 0, // 体验用户数量
        login_count: 0, //  今日登录数量
        pass_user_count: 0, // 过期用户数量
        place_data: [], // 全部的用户地区分布
        use_user_count: 0, // 未过期
        resume_clue_total_data: 0,
        resume_total_count: 0,
      },
      clue_list_date: [],
      clue_list_name: [],
      clue_list_value: [],
      resume_dict_date: [],
      resume_dict_name: 0,
      resume_dict_value: [],
      resume_dict_number: 0,
      lwbus_day_data: {},
      lwbus_month_data: {},
    };
  },
  created() {
    this.lwbus_isdata();
    this.lwbus_data();
    this.resume_clue_data();
    this.resume_info();
  },
  computed: {
    experience_place_datacount() {
      let int = 0;
      this.lw_data.experience_place_data.map((item) => {
        int = int + item.place_count;
      });
      return int;
    },
  },
  methods: {
    go_city_details(type,item) {
      this.$router.push({
        path: "/lwbus_city_company",
        query: { type:type,src: item.company_city_id?item.company_city_id:item.name },
      });
    },
    go_details(src, date, user) {
      // src 传值 date判断是今日还是30日 user判断是否为用户数据
      this.$router.push({
        path: "/lwbus_company",
        query: { src: src, date: date, user: user },
      });
    },
    lwbus_isdata() {
      this.loading = true;
      require("post", "/lwbus_user/v1/lwbus_day_data/", {}).then((res) => {
        if (!res.code) {
          this.lwbus_day_data = res.data;
        }
        this.loading = false;
      });
      require("post", "/lwbus_user/v1/lwbus_month_data/", {}).then((res) => {
        if (!res.code) {
          this.lwbus_month_data = res.data;
        }
        this.loading = false;
      });
    },
    lwbus_data() {
      this.loading = true;
      require("post", "/lwbus_user/v1/lwbus_data/", {}).then((res) => {
        if (!res.code) {
          console.log("用户", res.data);
          this.lw_data = res.data;
          // this.chart_lw_data()
          // this.lw_data_be_overdue()
        }
        this.loading = false;
        console.log("内容", res);
      });
    },
    resume_clue_data() {
      this.clue_data_loading = true;
      require("post", "/lwbus_user/v1/resume_clue_data/", {}).then((res) => {
        if (!res.code) {
          this.clue_list_name = [];
          this.clue_list_value = [];
          for (var key in res.data) {
            // console.log('当前显示内容1', key, res.data.clue_list[key])
            this.clue_list_date.push({ name: key, value: res.data[key] });
            this.clue_list_name.push(key);
            this.clue_list_value.push(res.data[key]);
          }
          // this.clue_list_data()
        }
        this.clue_data_loading = false;
        console.log("内容", res);
      });
    },
    resume_info() {
      this.info_loading = true;
      require("post", "/lwbus_user/v1/lufish_resume_info/", {}).then((res) => {
        if (!res.code) {
          for (var key in res.data.resume_dict) {
            // console.log('当前显示内容2', key, res.data.resume_dict[key])
            this.resume_dict_date.push({
              name: key == "" ? "其他" : key,
              value: res.data.resume_dict[key],
            });
            if (key == "未填写期望地点") {
              this.resume_dict_name = res.data.resume_dict[key];
              console.log("简历空", res.data.resume_dict[key]);
            }
            // this.resume_dict_name.push(key)
            // this.resume_dict_value.push(res.data.resume_dict[key])
          }
          this.resume_dict_date = this.resume_dict_date.filter((item) => {
            return item.name != "未填写期望地点";
          });
          // this.resume_dict_number = ''
          // this.resume_dict_data()
        }
        this.info_loading = false;
        console.log("内容", res);
      });
    },
    // chart_lw_data() {
    //   // 地区分布
    //   let that = this
    //   let let_place_data_place_count = []
    //   let let_place_data_place_name = []
    //   this.lw_data.place_data.forEach((item, index) => {
    //     let_place_data_place_count.push(item.place_count)
    //     let_place_data_place_name.push(item.place_name)
    //   })
    //   let lw_data = this.$echarts.init(document.getElementById('lw_data')) // 柱状图
    //   lw_data.setOption({
    //     title: {
    //       text: '城市分布',
    //       textStyle: {
    //         fontSize: 14,
    //         fontWeight: 'normal',
    //       },
    //     },
    //     tooltip: {
    //       formatter: function (value) {
    //         return value.name + ': ' + value.data
    //       },
    //     },
    //     xAxis: {
    //       type: 'category',
    //       data: let_place_data_place_name,
    //       axisLabel: {
    //         show: true,
    //         interval: 0,
    //         rotate: -90,
    //         textStyle: {
    //           color: '#bbb',
    //         },
    //       },
    //     },
    //     yAxis: {
    //       type: 'value',
    //     },
    //     color: '#6395F9',
    //     series: [
    //       {
    //         data: let_place_data_place_count,
    //         type: 'bar',
    //         // barWidth: 20, //柱图宽度
    //         showBackground: true,
    //         backgroundStyle: { color: 'rgba(225, 225, 225, 0.9)' },
    //         itemStyle: {},
    //       },
    //     ],
    //   })
    // },
    // lw_data_be_overdue() {
    //   // 过期分布
    //   let be_overdue_place_count = []
    //   let be_overdue_place_name = []
    //   this.lw_data.experience_place_data.forEach((item, index) => {
    //     be_overdue_place_count.push(item.place_count)
    //     be_overdue_place_name.push(item.place_name)
    //   })
    //   console.log(
    //     '过期信息',
    //     this.lw_data.experience_place_data,
    //     be_overdue_place_count,
    //     be_overdue_place_name
    //   )
    //   let lw_data_be_overdue = this.$echarts.init(
    //     document.getElementById('lw_data_be_overdue')
    //   ) // 柱状图
    //   lw_data_be_overdue.setOption({
    //     title: {
    //       text: '体验账号城市分布',
    //       textStyle: {
    //         fontSize: 14,
    //         fontWeight: 'normal',
    //       },
    //     },
    //     tooltip: {
    //       formatter: function (value) {
    //         return value.name + ': ' + value.data
    //       },
    //     },
    //     xAxis: {
    //       type: 'category',
    //       data: be_overdue_place_name,
    //       axisLabel: {
    //         show: true,
    //         interval: 0,
    //         rotate: -90,
    //         textStyle: {
    //           color: '#bbb',
    //         },
    //       },
    //     },
    //     yAxis: {
    //       type: 'value',
    //     },
    //     color: '#6395F9',
    //     series: [
    //       {
    //         data: be_overdue_place_count,
    //         type: 'bar',
    //         // barWidth: 20, //柱图宽度
    //         showBackground: true,
    //         backgroundStyle: { color: 'rgba(225, 225, 225, 0.9)' },
    //         itemStyle: {},
    //       },
    //     ],
    //   })
    // },

    // clue_list_data() {
    //   let that = this
    //   let clue_list = this.$echarts.init(document.getElementById('clue_list')) // 柱状图
    //   let clue_list_name_data = []
    //   this.clue_list_name.forEach((item) => {
    //     if (item == 'null') {
    //       item = '未填'
    //     }
    //     clue_list_name_data.push(item)
    //   })
    //   clue_list.setOption({
    //     title: {
    //       text: '城市雷达线索',
    //       textStyle: {
    //         fontSize: 14,
    //         fontWeight: 'normal',
    //       },
    //     },
    //     tooltip: {
    //       formatter: function (value) {
    //         return value.name + ': ' + value.data
    //       },
    //     },
    //     xAxis: {
    //       type: 'category',
    //       data: clue_list_name_data,
    //       axisLabel: {
    //         show: true,
    //         interval: 0,
    //         rotate: -90,
    //         textStyle: {
    //           color: '#bbb',
    //         },
    //       },
    //     },
    //     yAxis: {
    //       type: 'value',
    //     },
    //     color: '#6395F9',
    //     series: [
    //       {
    //         data: that.clue_list_value,
    //         type: 'bar',
    //         // barWidth: 20, //柱图宽度
    //         showBackground: true,
    //         backgroundStyle: { color: 'rgba(225, 225, 225, 0.9)' },
    //         itemStyle: {},
    //       },
    //     ],
    //   })
    // },
    // resume_dict_data() {
    //   let that = this
    //   let resume_dict = this.$echarts.init(
    //     document.getElementById('resume_dict')
    //   ) // 柱状图
    //   let resume_dict_name_data = []
    //   this.resume_dict_name.forEach((item) => {
    //     if (item == 'null') {
    //       item = '未填'
    //     }
    //     resume_dict_name_data.push(item)
    //   })
    //   resume_dict.setOption({
    //     title: {
    //       text: '城市简历分布',
    //       textStyle: {
    //         fontSize: 14,
    //         fontWeight: 'normal',
    //       },
    //     },
    //     tooltip: {
    //       formatter: function (value) {
    //         return value.name + ': ' + value.data
    //       },
    //     },
    //     xAxis: {
    //       type: 'category',
    //       data: resume_dict_name_data,
    //       axisLabel: {
    //         show: true,
    //         interval: 0,
    //         rotate: -90,
    //         textStyle: {
    //           color: '#bbb',
    //         },
    //       },
    //     },
    //     yAxis: {
    //       type: 'value',
    //     },
    //     color: '#6395F9',
    //     series: [
    //       {
    //         data: that.resume_dict_value,
    //         type: 'bar',
    //         // barWidth: 20, //柱图宽度
    //         showBackground: true,
    //         backgroundStyle: { color: 'rgba(225, 225, 225, 0.9)' },
    //         itemStyle: {},
    //       },
    //     ],
    //   })
    // },
  },
};
</script>

<style>
.lw_busadd {
  background: white;
}
#lw_data {
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.08);
}
.lw_center {
  overflow: auto;
  font-weight: bold;
}
.lw_center > p {
  padding: 0 0 12px 0;
  border-bottom: #bdbdbd solid 1px;
  font-size: 18px;
  font-weight: bold;
}
.Information_sorting {
  /* border:1px red solid; */
  float: left;
  width: 140px;
  padding: 0 12px;
  height: 96px;
  display: flex;
  margin: 12px 20px;
  /* box-shadow: #e0dddd 3px 4px 8px 2px; */
}
.Information_sorting img,
.Information_sorting .img {
  display: block;
  height: 24px;
  width: 24px;
  margin-right: 10px;
  margin-top: 12px;
  font-size: 22px;
}
.Information_sorting p {
  color: #303030;
  font-size: 14px;
  margin-bottom: 20px;
  text-align: center;
}
.Information_sorting > div {
  text-align: center;
}
.Information_sorting > div > span {
  color: #303030;
  font-size: 14px;
  margin-bottom: 20px;
}
.pointer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/index/lw_index.vue